import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciRadioComponent } from './luci-radio.component';



@NgModule({
  declarations: [LuciRadioComponent],
  exports: [LuciRadioComponent],
  imports: [
    CommonModule
  ]
})
export class LuciRadioModule { }
